import { Button, Dialog } from '@wonderschool/common-base-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteDialog from '../../../Components/Shared/DeleteDialog';

interface DeleteContactConfirmationDialogProps {
  isOpen: boolean;
  onYes: () => Promise<any> | void;
  onClose: () => void;
  isResponsibleForBilling: boolean;
}

export default function DeleteContactConfirmationDialog({
  isOpen,
  onYes,
  onClose,
  isResponsibleForBilling,
}: DeleteContactConfirmationDialogProps) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  if (!onYes || !onClose) throw new Error('onYes and onClose are required');
  if (isResponsibleForBilling) {
    return (
      <Dialog isOpen={!!isOpen} onClose={onClose} hasCloseButton={true} fullScreenOnMobile={true}>
        <Dialog.Panel>
          <Dialog.Title data-testid="delete-family-modal-title">
            {t('familyList.deleteContactConfirmationDialog.primaryPayer.title')}
          </Dialog.Title>
          {t('familyList.deleteContactConfirmationDialog.primaryPayer')}
        </Dialog.Panel>
        <Dialog.Actions>
          <Button
            loading={isLoading}
            onClick={onClose}
            extraClasses="w-full"
            primary
            label={t('common.close')}
            data-testid="delete-contact-no-btn"
          />
        </Dialog.Actions>
      </Dialog>
    );
  }

  return (
    <DeleteDialog
      title={t('familyList.deleteContactConfirmationDialog.nonPrimaryPayer.title')}
      message={t('familyList.deleteContactConfirmationDialog.nonPrimaryPayer')}
      onDelete={onYesLocal}
      onClose={onClose}
      isOpen={isOpen}
      isLoading={isLoading}
    />
  );

  async function onYesLocal(e: React.MouseEvent) {
    if (e) e.preventDefault();

    try {
      setIsLoading(true);
      await onYes();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }
}
